import { ClientPricingItemAdjustmentStatusEnum } from '../../../../../../../../../../lib/graphql'

export enum UpdateQuoteTableRowTypeEnum {
  REMOVED = 'REMOVED',
  ADDED = 'ADDED',
  DEFAULT = 'DEFAULT',
}

export const getUpdateQuoteTableRowType = (
  adjustmentStatus?: ClientPricingItemAdjustmentStatusEnum,
) => {
  if (adjustmentStatus === ClientPricingItemAdjustmentStatusEnum.ADDED) {
    return UpdateQuoteTableRowTypeEnum.ADDED
  } else if (
    adjustmentStatus === ClientPricingItemAdjustmentStatusEnum.REMOVED
  ) {
    return UpdateQuoteTableRowTypeEnum.REMOVED
  } else {
    return UpdateQuoteTableRowTypeEnum.DEFAULT
  }
}

export const getBackgroundColorByTableRowType = (
  type: UpdateQuoteTableRowTypeEnum,
) => {
  if (type === UpdateQuoteTableRowTypeEnum.ADDED) {
    return 'bg-green-100'
  } else if (type === UpdateQuoteTableRowTypeEnum.REMOVED) {
    return 'bg-red-100'
  } else {
    return ''
  }
}
